import { checkWebOrApp } from '../native';

export const handleLinkClick = (event: MouseEvent) => {
	const target = event.target as HTMLElement;
	if (target.tagName === 'IMG') {
		event.preventDefault(); // 기본 링크 동작 방지

		const parentAnchor = target.closest('a'); // <img>의 가장 가까운 <a> 태그 찾기

		if (parentAnchor) {
			event.preventDefault(); // <a> 태그의 기본 동작 방지
			const url = parentAnchor.getAttribute('href') ?? '';

			if (checkWebOrApp() === 'AOS') {
				return window.masterpick.nativeUrlOpenBrowser(url);
			}
			if (checkWebOrApp() === 'IOS') {
				return window.webkit?.messageHandlers?.nativeUrlOpenBrowser?.postMessage(url);
			}
			if (checkWebOrApp() === 'Web') {
				return window.open(url, '_blank'); // 새 탭에서 링크 열기
			}
		}
	}
};
